/* fx-launch.js: pre-launch polish, 22 Sep 2026. Pairs with fx-launch.css.
   1. Find your part modal: marks the modal while the search form shows, plain
      labels, dollar prices on part name results, image fade in.
   2. Model sheet: spec group headings are labels, so they leave the tab order.
   3. Product page gallery: loading state while a slide's image decodes.
   4. More compatible parts: In stock only switch, on by default, as on the
      VIN matched grid, plus dealer prices on its cards.
   5. Product page: the shipping policy link opens in its own tab.
   6. VIN matched hero: one held entrance instead of a three way race.
   Plus the .fx-dim marking on the identify strip, which the stylesheet uses
   instead of :has(). The Model and year tab's matching is in fx-launch-b.js.
*/
(function () {
  "use strict";

  var frame = 0;
  var stockOn = true;

  function txt(el, from, to) {
    if (el && el.textContent.trim() === from) el.textContent = to;
  }

  /* Same rule as snippets/fx-dealer-price.liquid and the extension: Shopify
     FLOORS the fractional cent of the discount (checked in the cart on
     22 Sep: $262.08 takes 5241 cents off). Keep the 20 in step with both. */
  function dealerOff(cents) { return Math.floor((cents * 20) / 100); }

  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /* 1. Find your part */
  function findModal() {
    var content = document.querySelector(".vin-modal .vin-modal-content");
    if (!content) return;
    var form = document.getElementById("vinSearchForm");
    var on = !!form && getComputedStyle(form).display !== "none";
    content.classList.toggle("fx-find", on);
    if (!on) return;

    txt(document.getElementById("vinModalTitle"), "Find Your Part", "Find your part");
    txt(document.getElementById("vinModalDescription"), "Search by VIN, part name, or filters.", "Search by VIN, by part name, or by your trailer model.");
    txt(document.getElementById("vinTabVin"), "VIN number", "VIN");
    txt(document.getElementById("vinTabFilters"), "Filters", "Model & year");
    var help = document.getElementById("vinPartNameHelp");
    if (help && /No button needed/.test(help.textContent)) help.textContent = "Results appear as you type.";
    var fhelp = document.getElementById("vinFilterSearchHelp");
    txt(fhelp, "Choose model year and/or model name.", "Choose a model year, a model name, or both.");
    var note = content.querySelector(".vin-predictive-limit-note");
    if (note && /predictive search limit/i.test(note.textContent)) note.textContent = "Showing the top 10 matches. Add a word to narrow it down.";

    var prices = content.querySelectorAll(".vin-predictive-price:not([data-fx-p])");
    for (var i = 0; i < prices.length; i++) {
      var p = prices[i];
      var raw = p.textContent.replace(/[^0-9.]/g, "");
      p.setAttribute("data-fx-p", "1");
      if (!raw) continue;
      var cents = Math.round(parseFloat(raw) * 100);
      if (window.fxDealer) {
        p.textContent = "";
        var was = document.createElement("s");
        was.className = "fx-pp-was";
        was.textContent = money(cents);
        p.appendChild(was);
        p.appendChild(document.createTextNode(money(cents - dealerOff(cents))));
      } else {
        p.textContent = money(cents);
      }
    }

    var imgs = content.querySelectorAll(".vin-predictive-thumb img:not([data-fx-i])");
    for (var j = 0; j < imgs.length; j++) {
      (function (img) {
        img.setAttribute("data-fx-i", "1");
        var reveal = function () { img.classList.add("fx-in"); };
        if (!img.complete) {
          var src = img.getAttribute("src") || "";
          if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) {
            img.setAttribute("src", src + (src.indexOf("?") > -1 ? "&" : "?") + "width=480");
          }
          img.addEventListener("load", reveal, { once: true });
          img.addEventListener("error", reveal, { once: true });
        } else {
          reveal();
        }
      })(imgs[j]);
    }
  }

  /* Identify your trailer: mark the cards that are not the pick, so the
     stylesheet can shrink them without a :has() selector. See fx-launch.css. */
  function ident() {
    var rows = document.querySelectorAll(".ident-scroller");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var picked = row.querySelector(".ident-card.is-picked");
      row.classList.toggle("fx-has-pick", !!picked);
      var cards = row.querySelectorAll(".ident-card");
      for (var j = 0; j < cards.length; j++) {
        cards[j].classList.toggle("fx-dim", !!picked && !cards[j].classList.contains("is-picked"));
      }
    }
  }

  /* 2. Model sheet spec headings */
  function sheet() {
    var heads = document.querySelectorAll(".ident-sheet.fx-v2 .fx-ms__specs .ident-acc summary:not([data-fx-s])");
    for (var i = 0; i < heads.length; i++) {
      heads[i].setAttribute("data-fx-s", "1");
      heads[i].setAttribute("tabindex", "-1");
      heads[i].addEventListener("click", function (e) { e.preventDefault(); });
      var d = heads[i].parentElement;
      if (d && d.tagName === "DETAILS") d.open = true;
    }
  }

  /* 3. Gallery loading state */
  function watchImage(img) {
    if (img.getAttribute("data-fx-g")) return;
    img.setAttribute("data-fx-g", "1");
    var box = img.closest(".product__media");
    if (!box) return;
    if (img.complete && img.naturalWidth > 0) return;
    box.classList.add("fx-media-wait");
    var done = function () {
      var finish = function () { box.classList.remove("fx-media-wait"); };
      if (img.decode) img.decode().then(finish, finish); else finish();
    };
    img.addEventListener("load", done, { once: true });
    img.addEventListener("error", function () { box.classList.remove("fx-media-wait"); }, { once: true });
  }

  /* The short fade when a slide becomes active.
     16 Oct: this used to toggle the fx-media-swap class on the slide, with a
     forced reflow in between. The observer below watches class changes on
     those same slides, so its own toggle fired it again, it toggled again,
     and the page never got control back: a hard freeze ("Page Unresponsive")
     on any click back to a slide whose image had already loaded. Two rules
     now keep it from ever feeding itself:
     - it acts only when a slide GAINS is-active (attributeOldValue), never
       on a change to a slide that was already active;
     - the fade runs on the Web Animations API, which writes no attribute,
       so there is no mutation for anything to observe.
     The .fx-media-swap rules in fx-launch-b.css are no longer used. */
  var reduceMotion = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  function wasActive(oldClass) { return /(^|\s)is-active(\s|$)/.test(oldClass || ""); }
  function fadeIn(img) {
    if (!img.animate || (reduceMotion && reduceMotion.matches)) return;
    img.animate([{ opacity: 0.25 }, { opacity: 1 }], { duration: 320, easing: "ease" });
  }
  function fadeWhenActive(li, img) {
    return function () { if (li.classList.contains("is-active")) fadeIn(img); };
  }

  function gallery() {
    var imgs = document.querySelectorAll("media-gallery .product__media img");
    for (var i = 0; i < imgs.length; i++) watchImage(imgs[i]);
    var g = document.querySelector("media-gallery");
    if (g && !g.getAttribute("data-fx-g")) {
      g.setAttribute("data-fx-g", "1");
      new MutationObserver(function (list) {
        var done = [];
        for (var k = 0; k < list.length; k++) {
          var li = list[k].target;
          if (!li.classList || !li.classList.contains("product__media-item")) continue;
          if (!li.classList.contains("is-active")) continue;
          if (wasActive(list[k].oldValue)) continue;
          if (done.indexOf(li) > -1) continue;
          done.push(li);
          var img = li.querySelector(".product__media img");
          if (!img) continue;
          if (img.getAttribute("loading") === "lazy") img.setAttribute("loading", "eager");
          watchImage(img);
          /* Dawn re-assigns the active image's src on every switch (for its
             screen reader announcement), so even a cached image is briefly
             not complete here. Fade on its load instead, if still active. */
          if (img.complete && img.naturalWidth > 0) fadeIn(img);
          else img.addEventListener("load", fadeWhenActive(li, img), { once: true });
        }
      }).observe(g, { attributes: true, attributeFilter: ["class"], attributeOldValue: true, subtree: true });
    }
  }

  /* 4. More compatible parts, In stock only.
     The switch sits on the Category heading row, on the right, because the
     section heading and its count line are gone. */
  function stock() {
    var grid = document.getElementById("vcpMoreGrid");
    var sec = document.getElementById("vcpMoreParts");
    if (!grid || !sec || !grid.querySelector(".diagram-card")) return;
    var catHead = document.getElementById("vcpMoreCatHeading");
    var block = catHead && catHead.parentElement;
    if (!block) return;

    if (!block.querySelector(".vin-fx-stock-toggle")) {
      block.classList.add("fx-has-stock");
      var t = document.createElement("div");
      t.className = "vin-fx-stock-toggle";
      var lab = document.createElement("span");
      lab.className = "vin-fx-stock-toggle-label";
      lab.id = "fxVcpStockLabel";
      lab.textContent = "In stock only";
      var sw = document.createElement("button");
      sw.type = "button";
      sw.className = "vin-fx-switch";
      sw.setAttribute("role", "switch");
      sw.setAttribute("aria-labelledby", "fxVcpStockLabel");
      var q = document.createElement("span");
      q.className = "vin-fx-help";
      q.setAttribute("role", "note");
      q.setAttribute("tabindex", "0");
      q.setAttribute("data-tip", "Toggle to show all parts");
      q.setAttribute("aria-label", "Toggle to show all parts");
      q.textContent = "?";
      t.appendChild(lab); t.appendChild(sw); t.appendChild(q);
      catHead.insertAdjacentElement("afterend", t);
      sw.addEventListener("click", function () { stockOn = !stockOn; paintStock(); });
    }
    if (!sec.querySelector(".fx-vcp-none")) {
      var none = document.createElement("p");
      none.className = "fx-vcp-none";
      none.hidden = true;
      none.appendChild(document.createTextNode("None of these are in stock right now. "));
      var all = document.createElement("button");
      all.type = "button";
      all.textContent = "Show all parts";
      all.addEventListener("click", function () { stockOn = false; paintStock(); });
      none.appendChild(all);
      grid.parentNode.insertBefore(none, grid.nextSibling);
    }
    paintStock();
  }

  function paintStock() {
    var grid = document.getElementById("vcpMoreGrid");
    var sec = document.getElementById("vcpMoreParts");
    if (!grid || !sec) return;
    grid.classList.toggle("fx-instock", stockOn);
    var sw = sec.querySelector(".vin-fx-stock-toggle .vin-fx-switch");
    if (sw) {
      sw.classList.toggle("vin-fx-switch--on", stockOn);
      sw.setAttribute("aria-checked", stockOn ? "true" : "false");
    }
    if (window.fxDealer) {
      var ps = grid.querySelectorAll(".vin-fx-card-price:not([data-fx-p])");
      for (var d = 0; d < ps.length; d++) {
        var el = ps[d];
        el.setAttribute("data-fx-p", "1");
        if (el.querySelector(".vin-price-was")) continue;
        var raw = el.textContent.replace(/[^0-9.]/g, "");
        if (!raw) continue;
        var c = Math.round(parseFloat(raw) * 100);
        el.textContent = "";
        var was = document.createElement("s");
        was.className = "vin-price-was";
        was.textContent = money(c);
        var now = document.createElement("span");
        now.className = "vin-price-now";
        now.textContent = money(c - dealerOff(c));
        el.appendChild(was); el.appendChild(now);
      }
    }
    var none = sec.querySelector(".fx-vcp-none");
    if (!none) return;
    var cards = grid.querySelectorAll(".diagram-card");
    var shown = 0;
    for (var i = 0; i < cards.length; i++) if (cards[i].getClientRects().length) shown++;
    var extEmpty = document.getElementById("vcpMoreEmpty");
    var extShowing = extEmpty && extEmpty.getClientRects().length > 0;
    none.hidden = !(stockOn && cards.length && shown === 0 && !extShowing);
  }

  /* 5. Product page odds and ends: the shipping policy link opens in its own
     tab, because in place it fights the app extension's own navigation and
     bounces the customer back to the product. */
  function pdpBits() {
    var ship = document.querySelector(".product__tax a[href*='/policies/']");
    if (ship && !ship.getAttribute("data-fx-t")) {
      ship.setAttribute("data-fx-t", "1");
      ship.setAttribute("target", "_blank");
      ship.setAttribute("rel", "noopener");
    }
  }

  /* 6. VIN matched hero: hold the entrance until the render has decoded, then
     play one sequence. Capped, so a slow image never leaves the hero blank. */
  var heroToken = 0;
  function hero() {
    var results = document.getElementById("vinResults");
    var el = results && results.querySelector(".vin-fx-hero");
    if (!el) return;
    var open = results.getClientRects().length > 0;
    if (!open) {
      el.classList.remove("fx-hero-in", "fx-hero-wait");
      el.removeAttribute("data-fx-hero");
      return;
    }
    if (el.getAttribute("data-fx-hero")) return;
    el.setAttribute("data-fx-hero", "1");
    el.classList.add("fx-hero-wait");
    var mine = ++heroToken;
    var play = function () {
      if (mine !== heroToken) return;
      el.classList.remove("fx-hero-wait");
      el.classList.add("fx-hero-in");
      setTimeout(function () { el.classList.remove("fx-hero-in"); }, 1200);
    };
    var img = el.querySelector(".vin-fx-trailer-img");
    var capped = setTimeout(play, 700);
    var go = function () { clearTimeout(capped); play(); };
    if (img && img.getAttribute("src")) {
      if (img.complete && img.naturalWidth > 0) {
        if (img.decode) img.decode().then(go, go); else go();
      } else {
        img.addEventListener("load", go, { once: true });
        img.addEventListener("error", go, { once: true });
      }
    }
  }

  function tick() {
    frame = 0;
    findModal();
    ident();
    sheet();
    gallery();
    pdpBits();
    hero();
    stock();
  }
  /* A timer, not requestAnimationFrame: rAF is paused while the tab is in the
     background, and everything above has to be right the moment the tab comes
     back rather than one frame later. 40ms is below anything anyone sees. */
  function schedule() {
    if (frame) return;
    frame = setTimeout(function () { frame = 0; tick(); }, 40);
  }
  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "hidden", "class"] });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
